export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-v4compatibility.ttf?4baccb548138840fa33a2004ea6572e9";